export default "__VITE_ASSET__BgF6q$oi__"